import { useEffect } from 'react';
import { useStore } from '@/store/store';
import { usePathname } from 'next/navigation';

export const useNavigationChange = () => {
    const handleHideLoading = useStore((s) => s.loading.handleHideLoading);
    const pathname = usePathname();

    useEffect(() => {
        handleHideLoading();
    }, [pathname]);
};
